var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isVisible && _vm.outcome !== 0)?_c('cv-toast-notification',{staticClass:"pipeline-validation-notification",attrs:{"title":_vm.$t(`validators.${_vm.type}`),"sub-title":_vm.data.fileName,"caption":_vm.$tc(`validators.${_vm.type}_MSG`, _vm.outcome, {
      message: this.data.message,
    }),"kind":_vm.kind,"hide-close-button":_vm.kind === 'error',"low-contrast":false},on:{"close":function($event){_vm.isVisible = false}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }